import React, { useEffect, useState } from "react";
import Constaint from "../../../layout/components/Constaint";
import StartMockBtn from "./StartMockBtn";

const FeaturedVideo = () => {
  const [dimensions, setDimensions] = useState({ width: 560, height: 315 });

  useEffect(() => {
    const updateDimensions = () => {
      const windowWidth = window.innerWidth;

      if (windowWidth >= 1024) {
        // Large screens (Desktop)
        setDimensions({ width: 800, height: 450 });
      } else if (windowWidth >= 768) {
        // Medium screens (Tablet)
        setDimensions({ width: 640, height: 360 });
      } else {
        // Small screens (Mobile)
        setDimensions({ width: 360, height: 202 });
      }
    };
    // Initial check
    updateDimensions();

    // Update dimensions on resize
    window.addEventListener("resize", updateDimensions);

    // Cleanup on unmount
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div>
      <Constaint>
        <div className="grid p-16 mt-10 mb-24 place-content-center">
          <div className=" flex items-center flex-col gap-2 mb-4">
            <h3 className="text-2xl font-bold text-center text-gray-900">
              Meet FiBi AI — See It in Action
            </h3>

            <p className="max-w-3xl mx-auto leading-relaxed text-gray-600 text-sm text-center">
              Your personalized interview trainer — now in your pocket. Practice
              with text and voice simulations, get instant feedback, and walk
              into your U.S. visa interview with confidence.
            </p>
          </div>

          <iframe
            width={dimensions.width}
            height={dimensions.height}
            className="border-t-[16px] border-Blue00"
            src="https://www.youtube.com/embed/CKJp2CoZSOY?si=UOnKlJjsMBU5p_Ps&amp;controls=1"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
          <div className="mx-auto mt-4 w-max">
            <StartMockBtn />
          </div>
        </div>
      </Constaint>
    </div>
  );
};

export default FeaturedVideo;
